import View from './view';

import { delay } from '../utils/promisify';

export default View.extend( {

    serialize() {
        const {attrs = [], customFields = []} = this.options;
        return {
            customFields,
            layerAttrFieldName: `format_adopted.${this.options.injectedName}`,
            taskFieldFieldName: `field_id_adopted.${this.options.injectedName}`,
            attrs: attrs.map( ({name}) => ({
                name,
                value: `{${name}}`,
            }) ),
        };
    },

    bindingHandlers: {

        arrayvalue: {
            // to DOM
            set($el, array) {
                const [el] = $el,
                    {arrayIndex} = el.dataset,
                    {propName} = el.dataset;

                if (arrayIndex >= array.length)
                    return $el.val( '' );

                const value = array[arrayIndex][propName];

                if (!el.__triggered_array_value__)
                    $el.val( value );
            },

            // to Model
            get($el, oldArray, event) {
                const [el] = $el,
                    {arrayIndex} = el.dataset,
                    {propName} = el.dataset;

                el.__triggered_array_value__ = true;
                delay( 100 ).then( () =>
                    el.__triggered_array_value__ = false );

                const resultArray = [...oldArray],
                    valueElement = resultArray[arrayIndex];

                valueElement[propName] = $el.val();

                this.view.model.trigger( 'change' );
                this.view.model.trigger( 'change:fields_mapping' );
                return resultArray;
            },
        },
    },

    bindingFilters: {
        taskFieldFree(taskFieldId, fieldsMapping, index, m) {
            return fieldsMapping.filter( (fieldMapping, mappingIndex) => index !== mappingIndex )
                .every( fieldMapping => +fieldMapping.field_id_adopted !== +taskFieldId );
        },
    }
} );


// WEBPACK FOOTER //
// ./src/js/view/service.objects.fields.mapping.js